// extracted by mini-css-extract-plugin
export default {"size-fixer":"table-vertical-size-fixer_size-fixer__Ipu9a"};